import exclusiveInterfaces from './interface';

// for development use
const useDummyInterfaces = false;

const interfaces = useDummyInterfaces
  ? require('mocks/subsidy/public').default
  : window.API.wrap(exclusiveInterfaces, 'xhrSubsidyPublic');

export default interfaces;
